module.exports = __webpack_public_path__ + "media/components/country-flag/static/ke-607f23868b87fe21deb7ec42d18daa07.svg";